import React, { useEffect, useRef, useState } from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Users, Calendar } from 'lucide-react';

const Organizations = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  const organizations = [
    {
      name: 'Linux Users Society',
      role: 'Volunteer Trainer',
      period: '2019 - Present',
      description: 'GNU/Linux System Administration trainer',
      current: true
    },
    {
      name: 'Free Software Society Students Chapter',
      role: 'R&D and Training Director / Co-Founder',
      period: 'March 2018 - June 2020',
      description:
        'Cooperative events with IEEE and the Biology Society. Trainer on C, Python, and GNU/Linux System Administration.',
      current: false
    }
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section
      id="organizations"
      ref={sectionRef}
      className="section-padding py-20 px-6"
    >
      <div className="max-w-6xl mx-auto">
        <div
          className={`transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <h2 className="section-title text-4xl md:text-5xl font-bold text-white mb-4">
            <span className="text-cyan-400 font-mono text-lg">06.</span> Organizations
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-cyan-400 to-blue-500 mb-12"></div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {organizations.map((org, index) => (
              <Card
                key={index}
                className="glass-card bg-white/5 backdrop-blur-lg border border-white/10 rounded-2xl overflow-hidden hover:border-cyan-400/30 transition-all duration-300 hover:shadow-lg hover:shadow-cyan-400/10"
              >
                <CardContent className="p-8">
                  <div className="flex items-start gap-4 mb-4">
                    <div className="p-3 bg-cyan-500/10 rounded-lg border border-cyan-400/20">
                      <Users className="w-6 h-6 text-cyan-400" />
                    </div>
                    <div className="flex-1">
                      <h3 className="text-xl font-bold text-white mb-2">
                        {org.name}
                      </h3>
                      <p className="text-cyan-400 font-semibold">{org.role}</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-2 text-gray-400 text-sm mb-3">
                    <Calendar className="w-4 h-4" />
                    <span>{org.period}</span>
                    {org.current && (
                      <span className="ml-2 px-2 py-0.5 bg-cyan-500/20 text-cyan-400 border border-cyan-400/50 rounded text-xs">
                        Active
                      </span>
                    )}
                  </div>
                  <p className="text-gray-300">{org.description}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Organizations;